<template>
  <div class="wall-surface-area__table-wrap">
    <div class="step-4__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row" style="margin-bottom:8px">
          <div class="sumarry-field__label">Total openable area (in m2):</div>
          <div class="summary-field__value">{{ step4.wfropObj.total_openable_area.toFixed(2) }}</div>
        </div>
        <div class="summary-field__row" style="margin-bottom:8px">
          <div class="sumarry-field__label">Total carpet area (in m2):</div>
          <div class="summary-field__value">{{ step4.wfropObj.total_carpet_area }}</div>
        </div>
        <div class="summary-field__row" style="margin-bottom:8px">
          <div class="sumarry-field__label">Openable window-to-floor area ratio -WFRop (in %):</div>
          <div class="summary-field__value">{{ step4.wfropObj.wfropPercent }}</div>
        </div>
      </div>
    </div>
    <hr />
    <div class="step4-wfrop-note">
      <v-alert dense text color="teal" icon="mdi-alert-circle">
        <span>Since the project location is in {{ schema.inputs.step1.climate_zone }}, climatic zone</span>, <span> minimum WFRop is {{ findMinWfrop }}% </span>
      </v-alert>
    </div>

    <hr />
    <div class="step4-conclusion-wrap">
      <div class="step4-conclusion-head">Conclusion:</div>
      <div class="step4-wfrop-conclusion" v-if="step4.wfropObj.wfropPercent > step4.wfropObj.minWfropPercent">
        <v-alert type="success" dense text>
          <span> The project does complies with the ECBC-R requirement of minimum WFRop</span>
        </v-alert>
      </div>
      <!-- If Invalid -->
      <div v-else class="step4-wfrop-conclusion_invalid">
        <v-alert type="error" text dense>
          <span> The project does not complies with the ECBC-R requirement of minimum WFRop</span>
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import { wfropData } from '@/constant_data/wfropData';
export default {
  components: {
    LvInput,
  },
  data() {
    return {
      wfropData,
      minWfropPercent: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },

    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step2) {
        this.$store.dispatch('setStep2', step2);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step4) {
        this.$store.dispatch('setStep4', step4);
      },
    },
    findMinWfrop() {
      for (let j = 0; j <= this.wfropData.length - 1; j++) {
        if (this.wfropData[j].climateZone == this.schema.inputs.step1.climate_zone) {
          this.step4.wfropObj.minWfropPercent = this.wfropData[j].minWfrop;
          console.log(this.step4.wfropObj.minWfropPercent);
          return this.step4.wfropObj.minWfropPercent;
        }
      }
    },
  },
  watch: {
    minWfropPercent: function() {
      this.findMinWfrop;
    },
  },
  created() {
    this.calculateTotalOpenableArea();
    this.totalCarpetArea();
    this.wfropCalculation();
  },
  methods: {
    calculateTotalOpenableArea() {
      this.step4.wfropObj.total_openable_area = +this.step3B.summary_window_openable.total_openable_area + +this.step3C.summary_ventilator_openable.total_openable_area + +this.step3C.summary_door_openable.total_openable_area;
      // return this.step4.wfropObj.total_openable_area;
    },
    totalCarpetArea() {
      let calcCarpetArea = 0;
      let finalCarpetArea = 0;
      for (let i = 0; i <= this.step2.houseTypeArrObj.length - 1; i++) {
        calcCarpetArea = calcCarpetArea + this.step2.houseTypeArrObj[i].carpet_area * this.step2.houseTypeArrObj[i].no_of_du;
      }
      finalCarpetArea = calcCarpetArea * this.step2.commonFields.no_of_floors;
      this.step4.wfropObj.total_carpet_area = finalCarpetArea.toFixed(2);
    },
    wfropCalculation() {
      this.step4.wfropObj.wfropPercent = +((this.step4.wfropObj.total_openable_area / this.step4.wfropObj.total_carpet_area) * 100).toFixed(2);
      // return this.step4.wfropObj.wfropPercent;
    },
  },
};
</script>

<style lang="scss" scoped>
.step-4__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 8px 0;
    .summary-block__wrap {
      display: flex;
      flex-direction: column;
      .summary-field__row {
        display: flex;
        justify-content: space-between;
      }
      .summary-field__label {
        font-size: 12px;
        color: #343f4b;
      }
    }
  }
}
.step4-conclusion-wrap {
  padding: 8px;
  .step4-conclusion-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 0px 0px 8px 0px;
  }
}
.step4-wfrop-note {
  // background-color: #e9f2fa;
  font-style: italic;
  padding: 8px;
  margin: 12px 0px;
}

.step4-wfrop-conclusion {
  border-radius: 4px;
  // background-color: #b3f5db;
  padding: 4px;
  text-align: center;
  border-radius: 4px;
}
.step4-wfrop-conclusion_invalid {
  // background-color: rgb(253, 180, 180);
  padding: 4px;
  // text-align: center;
  border-radius: 4px;
}
</style>
